import { IContainer } from '../interface/container';
import binderToast from './toast/binder';
import binderUserAlert from './useralert/binder';

async function binder(container: IContainer): Promise<void> {
    binderToast(container);
    binderUserAlert(container);
}

export default binder;
